module.exports = __webpack_public_path__ + "static/img/Kindle_Enter.76190893.png";